import { createAction } from '@ngrx/store';

export const disableStreetAndCityAction = createAction(
  '[Change Communication Address] Disable street and city'
);
